var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
export const useExitAppFlow = () => {
    _react_refresh_temp_1();
    const [isExitAppFlowInProgress, setIsExitAppFlowInProgress] = useState(false);
    return { isExitAppFlowInProgress, setIsExitAppFlowInProgress };
};
_react_refresh_temp_1(useExitAppFlow, "1pY3qhGdBqBNkdhKOXUvnUxvqa8=");
